const lessonExplorerUrl = '/lesson-explorer';

export default lessonExplorerUrl;
